module.exports = __webpack_public_path__ + "img/virtual-reality.d5cbef40.svg";